/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils

/* ++++++++++ --------------- EXPORT : DELETE USER : STYLES --------------- ++++++++++ */
export default theme =>({
  approvepopup: {
    extend: theme.modal.form,
    maxWidth: pxToEm(480),
    padding: `${pxToEm(8)} ${pxToEm(16)}`,
    '& .name-approvepopup':{
      '& .bodycopy':{
        marginTop:pxToEm(48),
        marginBottom: pxToEm(24),
        textAlign: 'center'
      }
    },
    '& .name-ctas':{
      marginTop:pxToEm(16)
    },
  }
});
